import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, Calendar } from 'lucide-react';

/**
 * Sticky bottom CTA bar — visible ONLY on mobile (hidden md+).
 * Three equal-width buttons: Call · WhatsApp · Book Demo.
 *
 * Drop into any page. Already responsive — no extra config needed.
 */
const PHONE   = '+919891550666';
const WA_LINK = 'https://wa.me/919891550666?text=Hi,%20I%27m%20interested%20in%20your%20courses.%20Please%20share%20details.';

const MobileCTABar = ({ courseName = '' }) => {
  const trackClick = (label) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'mobile_cta_click', { label, course: courseName });
    }
  };

  return (
    <>
      {/* Spacer so content isn't hidden behind the bar */}
      <div className="md:hidden" style={{ height: '76px' }} aria-hidden />

      <div
        data-testid="mobile-cta-bar"
        className="md:hidden fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-slate-200 shadow-[0_-4px_24px_rgba(0,0,0,0.12)]"
      >
        <div className="grid grid-cols-3 divide-x divide-slate-200">
          <a
            href={`tel:${PHONE}`}
            onClick={() => trackClick('call')}
            className="flex flex-col items-center justify-center gap-1 py-3 active:bg-orange-50"
            data-testid="mobile-cta-call"
          >
            <Phone className="w-5 h-5 text-orange-600" />
            <span className="text-[11px] font-bold text-slate-800">Call Now</span>
          </a>

          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick('whatsapp')}
            className="flex flex-col items-center justify-center gap-1 py-3 active:bg-green-50"
            data-testid="mobile-cta-whatsapp"
          >
            <MessageCircle className="w-5 h-5 text-green-600" />
            <span className="text-[11px] font-bold text-slate-800">WhatsApp</span>
          </a>

          <Link
            to="/book-demo"
            onClick={() => trackClick('book-demo')}
            className="flex flex-col items-center justify-center gap-1 py-3 bg-orange-600 text-white"
            data-testid="mobile-cta-book-demo"
          >
            <Calendar className="w-5 h-5" />
            <span className="text-[11px] font-bold">Book Demo</span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default MobileCTABar;
